import { theme as antdTheme } from "antd";

export const tenantColors = {
  primary: "#4b7cf3",
  primaryDark: "#315adf",
  primaryLight: "#42baf9",
  accent: "#0ea5e9",
  success: "#22c55e",
  warning: "#f59e0b",
  error: "#ef4444",
  white: "#ffffff",
  black: "#141322",
  slate900: "#0f172a",
  slate800: "#1e293b",
  slate700: "#334155",
  slate200: "#e2e8f0",
  slate100: "#f1f5f9",
  slate50: "#f8fafc",
};

export const sidebarWidth = 240;
export const collapsedSidebarWidth = 92;

export const getAntdThemeConfig = (mode = "light") => {
  const isLight = mode === "light";

  return {
    algorithm: isLight ? antdTheme.defaultAlgorithm : antdTheme.darkAlgorithm,
    token: {
      colorPrimary: tenantColors.primary,
      colorInfo: tenantColors.primaryLight,
      colorSuccess: tenantColors.success,
      colorWarning: tenantColors.warning,
      colorError: tenantColors.error,
      borderRadius: 10,
      borderRadiusLG: 14,
      fontFamily:
        '"Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
      fontSize: 14,
      controlHeight: 40,
      controlHeightLG: 48,
      colorBgBase: isLight ? tenantColors.white : tenantColors.black,
      colorTextBase: isLight ? tenantColors.slate900 : tenantColors.white,
      colorBgLayout: isLight ? tenantColors.slate50 : tenantColors.black,
      colorBgContainer: isLight ? tenantColors.white : tenantColors.slate800,
      colorBorder: isLight ? tenantColors.slate200 : tenantColors.slate700,
      colorBorderSecondary: isLight ? tenantColors.slate100 : tenantColors.slate700,
      colorText: isLight ? tenantColors.slate900 : tenantColors.white,
      colorTextSecondary: isLight ? tenantColors.slate700 : "#a5b4fc",
      colorFillAlter: isLight ? tenantColors.slate50 : "rgba(255,255,255,0.04)",
      colorFillSecondary: isLight ? "#eaf0ff" : "rgba(75,124,243,0.18)",
      boxShadowSecondary: "0 16px 48px rgba(15, 23, 42, 0.08)",
    },
    components: {
      Layout: {
        headerBg: isLight ? tenantColors.white : tenantColors.slate800,
        siderBg: isLight ? tenantColors.white : tenantColors.slate800,
        bodyBg: isLight ? tenantColors.slate50 : tenantColors.black,
        triggerBg: isLight ? tenantColors.white : tenantColors.slate800,
      },
      Menu: {
        itemBorderRadius: 10,
        itemHeight: 44,
        itemHoverBg: isLight ? "rgba(75, 124, 243, 0.08)" : "rgba(75, 124, 243, 0.15)",
        itemSelectedBg: "rgba(75, 124, 243, 0.14)",
        itemSelectedColor: tenantColors.primary,
        colorItemText: isLight ? tenantColors.slate900 : tenantColors.white,
        colorItemBg: "transparent",
        colorSubItemBg: "transparent",
      },
      Card: {
        borderRadiusLG: 14,
      },
      Table: {
        headerBg: isLight ? tenantColors.slate50 : tenantColors.slate800,
        headerColor: isLight ? tenantColors.slate700 : tenantColors.slate100,
        rowHoverBg: isLight ? "rgba(75, 124, 243, 0.04)" : "rgba(255,255,255,0.03)",
      },
      Button: {
        borderRadius: 10,
      },
      Input: {
        borderRadius: 10,
      },
      Select: {
        borderRadius: 10,
      },
      Modal: {
        borderRadiusLG: 16,
      },
      Tabs: {
        itemColor: isLight ? tenantColors.slate700 : tenantColors.slate100,
        itemSelectedColor: tenantColors.primary,
      },
      Steps: {
        dotSize: 10,
      },
    },
  };
};
